import React, { useState } from "react";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import { MuiSingleDateTimePicker } from "../muiSingleDateTimePicker";
import { Base } from "../../../framework/base";

export const MuiDataGridDateTimePicker = ({
    id,
    field,
    value,
    hasFocus,
    format,
}: GridRenderEditCellParams & { format?: string }) => {
    const [open, setOpen] = useState(hasFocus);
    const apiRef = useGridApiContext();

    const handleValueChange = async(newValue: string) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: newValue,
        });
    };

    // Strip timezone offset from value so the picker displays and edits the original
    // time digits without converting to browser local time. Output is also returned
    // without UTC conversion so dateStrToOriginalTimezoneJsonDateTime in handleSubmit
    // receives the correct time.
    const strippedValue = value ? Base.dateStrToOriginalTimezoneJsonDateTime(value) : "";

    return (
        <MuiSingleDateTimePicker
            open={open}
            setOpen={(open) => setOpen(open)}
            value={strippedValue}
            onChange={(val) => void handleValueChange(val)}
            fullWidth
            disableInputAdornment
            showCloseIcon
            asUtc={false}
            format={format}
            textFieldProps={{
                size: "small",
                variant: "standard",
                sx: { fontSize: "0.875rem" },
            }}
        />
    );
};
